import liff from "@line/liff";

const LIFF_ID = import.meta.env.VITE_LINE_MINI_APP_ID;

let initialized = false;

export async function initLiff(): Promise<void> {
  if (!LIFF_ID || initialized) return;
  try {
    await liff.init({ liffId: LIFF_ID });
    initialized = true;
  } catch (e) {
    console.error("LIFF init failed:", e);
  }
}

export function isInLiff(): boolean {
  if (!initialized) return false;
  return liff.isInClient();
}

export function isLiffLoggedIn(): boolean {
  if (!initialized) return false;
  return liff.isLoggedIn();
}

export function liffLogin(): void {
  liff.login();
}

export function getLiffAccessToken(): string | null {
  if (!initialized) return null;
  return liff.getAccessToken();
}

export function getLiffIdToken(): string | null {
  if (!initialized) return null;
  return liff.getIDToken();
}

export function isLiffEnabled(): boolean {
  return !!LIFF_ID;
}
